import {CDMOProfile} from "../components/CDMOProfile";

const CDMOProfileEditPage: React.FC = () => {
  return (
    <CDMOProfile mode="edit" />
  );
}


export default CDMOProfileEditPage